export default __webpack_public_path__ + "static/compareItemImg5-cb5e819cc2268979fa2261daebe593e1.png";